import { render, staticRenderFns } from "./MenuHorizontalRuleButton.vue?vue&type=template&id=ce54d0e8&"
import script from "./MenuHorizontalRuleButton.vue?vue&type=script&lang=ts&"
export * from "./MenuHorizontalRuleButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports